import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card card-with-loading bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "col-lg-6" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = { class: "text-danger" }

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import PageLoading from "@/components/Common/PageLoading.vue";
import { toast } from "vue-sonner";
import { ItemDataResponse } from "@/types/interface/item";
import { mapOptionMultiselect } from "@/utils/helper";
import { useVesselStore } from "@/stores/master/vessel";
import { VesselDataResponse } from "@/types/interface/vessel";
import { VesselItemPayload } from "@/types/interface/item-vessel";
import { useItemStore } from "@/stores/management/item";
import { useVesselItemStore } from "@/stores/management/item-vessel";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateItemVessel',
  setup(__props) {

const idItem = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const detailItem = ref<ItemDataResponse>();
const listVessel = ref<VesselDataResponse>();
const vesselStore = useVesselStore();
const itemStore = useItemStore();
const vesselItemStore = useVesselItemStore();
const listItems = ref([]);
const isVariant = ref(false);
const listVariant = ref([]);

const validationSchema = toTypedSchema(
  zod.object({
    id_vessel: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    id_goods: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    quantity: zod.number(),
    rob: zod.number(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: id_vessel } = useField<number>("id_vessel");
const { value: id_goods } = useField<number>("id_goods");
const { value: id_variant } = useField<number>("id_variant");
const { value: quantity } = useField<number>("quantity");
const { value: rob } = useField<number>("rob");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;

  const payloadVesselItem: VesselItemPayload = {
    vessel_id: id_vessel.value?.value,
    goods_id: id_goods.value.value,
    variant_id: id_variant.value?.value,
    quantity: quantity.value,
    rob: rob.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value) {
    responseApi.value = await vesselItemStore.dispatchUpdate(
      idItem.value,
      payloadVesselItem
    );
  } else {
    responseApi.value = await vesselItemStore.dispatchCreate(payloadVesselItem);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Vessel Item Successfully Updated"
          : "Vessel Item Successfully Added"
      );
      router.push("/management/vessel-item");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailItem = async () => {
  const { success, message } = await vesselItemStore.dispatchDetail(
    idItem.value
  );
  if (success) {
    detailItem.value = await vesselItemStore?.vesselItem?.data;
    if (detailItem.value.variant != null) {
      isVariant.value = true;
      id_variant.value = mapOptionMultiselect(
        detailItem.value?.variant,
        "id",
        "key",
        "value"
      );
    }
    id_vessel.value = mapOptionMultiselect(detailItem.value?.vessel);
    id_goods.value = mapOptionMultiselect(detailItem.value?.goods);
    quantity.value = detailItem.value?.quantity;
    rob.value = detailItem.value?.rob;
  }
};

const loadListItem = async () => {
  const { success } = await itemStore.dispatchGetItems(1, 99);
  if (success) {
    listItems.value = mapOptionMultiselect(itemStore.items.items);
  }
};

const loadListVessel = async () => {
  const { success } = await vesselStore.dispatchGetAll(1, 99);
  if (success) {
    listVessel.value = mapOptionMultiselect(vesselStore.vessels.items);
  }
};

const handleSelectGoods = async () => {
  let result = {};
  const { success } = await itemStore.dispatchDetail(id_goods.value?.value);
  if (success) {
    result = itemStore.item.data;
    if (result.variant.length > 0) {
      isVariant.value = true;
      listVariant.value = mapOptionMultiselect(
        result.variant,
        "id",
        "key",
        "value"
      );
    }
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idItem.value = router.currentRoute.value.params.id.toString();
    loadDetailItem();
  }
  loadListVessel();
  loadListItem();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(PageLoading, {
              key: 0,
              text: "Processing Data..."
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Item"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/management/vessel-item"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Item ")
            ])
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
            class: "row g-3 needs-validation form"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", {
                    for: "id_vessel",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Vesel "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(vSelect), {
                      options: listVessel.value,
                      name: "id_vessel",
                      modelValue: _unref(id_vessel),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(id_vessel) ? (id_vessel).value = $event : null)),
                      placeholder: "Choose Vessel"
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).id_vessel), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", {
                    for: "id_goods",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Item "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(vSelect), {
                      options: listItems.value,
                      name: "id_goods",
                      modelValue: _unref(id_goods),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(id_goods) ? (id_goods).value = $event : null)),
                      placeholder: "Choose Item",
                      onClose: handleSelectGoods
                    }, null, 8, ["options", "modelValue"])
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).id_goods), 1)
                ])
              ]),
              (isVariant.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "id_variant",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Varian "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(vSelect), {
                          options: listVariant.value,
                          name: "id_variant",
                          modelValue: _unref(id_variant),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(id_variant) ? (id_variant).value = $event : null)),
                          placeholder: "Choose Varian Item"
                        }, null, 8, ["options", "modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    for: "quantity",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Max Quantity "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      name: "quantity",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(quantity) ? (quantity).value = $event : null)),
                      placeholder: "Max Quantity",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(quantity)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(errors).quantity), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    for: "rob",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("ROB (Remaining On Board) "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      name: "rob",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(rob) ? (rob).value = $event : null)),
                      placeholder: "Remaining On Board",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, _unref(rob)]
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(errors).rob), 1)
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                _createElementVNode("button", {
                  class: "btn btn-primary fw-semibold text-white py-2 px-3",
                  type: "submit"
                }, " Save ")
              ], -1))
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})